import { http } from '../../config/axios'

export default function getSaldoCliente(idCliente:string): Promise<any> {
  return http
    .get(`api/cliente-saldo/saldo/${idCliente}`)
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro getSaldoCliente', error)
      throw Error(error.response.data)
    })
}
